// GENERAL MUTAION
export const GENERAL_CHANGE_VALUES = 'GENERAL_CHANGE_VALUES';

// CUSTOMER MUTATION
export const CUSTOMER_CHANGE_VALUE = 'CUSTOMER_CHANGE_VALUE';
export const CUSTOMER_CHANGE_VALUES = 'CUSTOMER_CHANGE_VALUES';
export const CUSTOMER_SET_CUSTOMERS = 'CUSTOMER_SET_CUSTOMERS';
export const CUSTOMER_CHANGE_TABLE_OPTION = 'CUSTOMER_CHANGE_TABLE_OPTION';
export const CUSTOMER_CHANGE_TABLE_SORT = 'CUSTOMER_CHANGE_TABLE_SORT';
export const CUSTOMER_CHANGE_PROFILE_TAB = 'CUSTOMER_CHANGE_PROFILE_TAB';

// CUSTOMER DETAIL MUTATION
export const CUSTOMER_DETAIL_CHANGE_VALUE = 'CUSTOMER_DETAIL_CHANGE_VALUE';
export const CUSTOMER_DETAIL_CHANGE_HVAC_VALUE = 'CUSTOMER_DETAIL_CHANGE_HVAC_VALUE';
export const CUSTOMER_DETAIL_SET_CUSTOMER = 'CUSTOMER_DETAIL_SET_CUSTOMER';
export const CUSTOMER_DETAIL_SET_FILTER = 'CUSTOMER_DETAIL_SET_FILTER';
export const CUSTOMER_DETAIL_SET_SORT = 'CUSTOMER_DETAIL_SET_SORT';
export const CUSTOMER_DETAIL_SET_ALERT = 'CUSTOMER_DETAIL_SET_ALERT';
export const CUSTOMER_DETAIL_SET_ACTIVITY = 'CUSTOMER_DETAIL_SET_ACTIVITY';
export const CUSTOMER_DETAIL_SET_CYCLES = 'CUSTOMER_DETAIL_SET_CYCLES';
export const CUSTOMER_DETAIL_SET_CYCLE_DETAIL = 'CUSTOMER_DETAIL_SET_CYCLE_DETAIL';
export const CUSTOMER_DETAIL_RESET_STATE = 'CUSTOMER_DETAIL_RESET_STATE';
export const CUSTOMER_DETAIL_SET_EDIT = 'CUSTOMER_DETAIL_SET_EDIT';
export const CUSTOMER_DETAIL_SET_HVAC_EDIT = 'CUSTOMER_DETAIL_SET_HVAC_EDIT';
export const CUSTOMER_DETAIL_EDIT_CUSTOMER = 'CUSTOMER_DETAIL_EDIT_CUSTOMER';
export const CUSTOMER_DETAIL_EDIT_CONTACT_INFO = 'CUSTOMER_DETAIL_EDIT_CONTACT_INFO';
export const CUSTOMER_DETAIL_UPDATE_HVAC = 'CUSTOMER_DETAIL_UPDATE_HVAC';
export const CUSTOMER_DETAIL_ERROR = 'CUSTOMER_DETAIL_ERROR';
export const CUSTOMER_DETAIL_SELECT_POINT = 'CUSTOMER_DETAIL_SELECT_POINT';
export const CUSTOMER_DETAIL_GENERATED_CSV = 'CUSTOMER_DETAIL_GENERATED_CSV';
export const CUSTOMER_DETAIL_FILTER_HVAC = 'CUSTOMER_DETAIL_FILTER_HVAC';
export const CUSTOMER_DETAIL_SET_EXPORT_RANGE = 'CUSTOMER_DETAIL_SET_EXPORT_RANGE';
export const CUSTOMER_DETAIL_RESET_EXPORT_RANGE = 'CUSTOMER_DETAIL_RESET_EXPORT_RANGE';
export const CUSTOMER_DETAIL_RESET_SELECT_POINT = 'CUSTOMER_DETAIL_RESET_SELECT_POINT';
export const CUSTOMER_DETAIL_CHANGE_CD_OPTIONS = 'CUSTOMER_DETAIL_CHANGE_CD_OPTIONS';
export const CUSTOMER_DETAIL_CHANGE_CO_OPTIONS = 'CUSTOMER_DETAIL_CHANGE_CO_OPTIONS';
export const CUSTOMER_DETAIL_RUNTIME_GRAPH = 'CUSTOMER_DETAIL_RUNTIME_GRAPH';
export const CUSTOMER_DETAIL_SET_ALERT_TAB = 'CUSTOMER_DETAIL_SET_ALERT_TAB';
export const CUSTOMER_DETAIL_RESET_ALERT_TAB = 'CUSTOMER_DETAIL_RESET_ALERT_TAB';
export const CUSTOMER_DETAIL_FILTER_ALERT_TAB = 'CUSTOMER_DETAIL_FILTER_ALERT_TAB';
export const CUSTOMER_DETAIL_FILTER_ACTIVITY_TAB = 'CUSTOMER_DETAIL_FILTER_ACTIVITY_TAB';
export const CUSTOMER_DETAIL_CHANGE_VALUES = 'CUSTOMER_DETAIL_CHANGE_VALUES';
export const CUSTOMER_DETAIL_SELECTED_IMAGE = 'CUSTOMER_DETAIL_SELECTED_IMAGE';
export const CUSTOMER_DETAIL_UPLOAD_IMAGE = 'CUSTOMER_DETAIL_UPLOAD_IMAGE';
export const CUSTOMER_DETAIL_SET_SUBSCRIPTION = 'CUSTOMER_DETAIL_SET_SUBSCRIPTION';
export const CUSTOMER_DETAIL_CANCEL_SUBSCRIPTION = 'CUSTOMER_DETAIL_CANCEL_SUBSCRIPTION';
export const CUSTOMER_DETAIL_SET_CHRONIC_ALERTS = 'CUSTOMER_DETAIL_SET_CHRONIC_ALERTS';
export const CUSTOMER_DETAIL_UPDATE_CHRONIC = 'CUSTOMER_DETAIL_UPDATE_CHRONIC';
export const CUSTOMER_DETAIL_SET_FILTERED_DATA = 'CUSTOMER_DETAIL_SET_FILTERED_DATA';
export const CUSTOMER_DETAIL_CLEAR_FILTERED_DATA = 'CUSTOMER_DETAIL_CLEAR_FILTERED_DATA';

// PARTNER ORDER MUTATION
export const PARTNER_ORDER_CHANGE_VALUE = 'PARTNER_ORDER_CHANGE_VALUE';
export const PARTNER_ORDER_SET_ORDER = 'PARTNER_ORDER_SET_ORDER';
export const PARTNER_ORDER_CHANGE_TABLE_OPTION = 'PARTNER_ORDER_CHANGE_TABLE_OPTION';

// SYSTEM HEALTH MUTATION
export const SYSTEM_HEALTH_CHANGE_VALUE = 'SYSTEM_HEALTH_CHANGE_VALUE';
export const SYSTEM_HEALTH_CHANGE_VALUES = 'SYSTEM_HEALTH_CHANGE_VALUES';
export const SYSTEM_HEALTH_CHANGE_TABLE_OPTION = 'SYSTEM_HEALTH_CHANGE_TABLE_OPTION';
export const SYSTEM_HEALTH_CHANGE_ALERT_TYPE = 'SYSTEM_HEALTH_CHANGE_ALERT_TYPE';
export const SYSTEM_HEALTH_SET_SYSTEM_HEALTH = 'SYSTEM_HEALTH_SET_SYSTEM_HEALTH';
export const SYSTEM_HEALTH_SET_HEADER_FILTER = 'SYSTEM_HEALTH_SET_HEADER_FILTER';
export const SYSTEM_HEALTH_SET_HEADER = 'SYSTEM_HEALTH_SET_HEADER';
export const SYSTEM_HEALTH_SET_EXPANDABLE_ROW = 'SYSTEM_HEALTH_SET_EXPANDABLE_ROW';
export const SYSTEM_HEALTH_RESET_SYSTEM_HEALTH = 'SYSTEM_HEALTH_RESET_SYSTEM_HEALTH';
export const SYSTEM_HEALTH_RESET_SYSTEM_HEALTH_LOADER = 'SYSTEM_HEALTH_RESET_SYSTEM_HEALTH_LOADER';
export const SYSTEM_HEALTH_SET_SYSTEM_HEALTH_AGAIN = 'SYSTEM_HEALTH_SET_SYSTEM_HEALTH_AGAIN';
export const SYSTEM_HEALTH_SET_EXPANDABLE_ROW_AGAIN = 'SYSTEM_HEALTH_SET_EXPANDABLE_ROW_AGAIN';
export const SYSTEM_HEALTH_CHANGE_ALERT_CATEGORY = 'SYSTEM_HEALTH_CHANGE_ALERT_CATEGORY';

// LEAD MUTATION
export const LEAD_CHANGE_VALUES = 'LEAD_CHANGE_VALUES';
export const LEAD_CHANGE_VALUE = 'LEAD_CHANGE_VALUE';
export const LEAD_RESET_ACTION_MODAL = 'LEAD_RESET_ACTION_MODAL';
export const LEAD_SET_LEAD = 'LEAD_SET_LEAD';
export const LEAD_UPDATE_ACTION_STATUS = 'LEAD_UPDATE_ACTION_STATUS';
export const LEAD_ERROR = 'LEAD_ERROR';
export const ADD_CURRENT_POSITION = 'ADD_CURRENT_POSITION';

// LEAD DETAIL MUTATION
export const LEAD_DETAIL_CHANGE_VALUE = 'LEAD_DETAIL_CHANGE_VALUE';
export const LEAD_DETAIL_SET = 'LEAD_DETAIL_SET';

// SERVICE REQUEST MUTATIONS
export const SERVICE_REQUEST_CHANGE_VALUE = 'SERVICE_REQUEST_CHANGE_VALUE';
export const SERVICE_REQUEST_CHANGE_TABLE_OPTION = 'SERVICE_REQUEST_CHANGE_TABLE_OPTION';
export const SERVICE_REQUEST_SET_REQUESTS = 'SERVICE_REQUEST_SET_REQUESTS';
export const SERVICE_REQUEST_CHANGE_CURRENT_SR = 'SERVICE_REQUEST_CHANGE_CURRENT_SR';
export const SERVICE_REQUEST_CHANGE_VALUES = 'SERVICE_REQUEST_CHANGE_VALUES';
export const SERVICE_REQUEST_RESET_ACTION_MODAL = 'SERVICE_REQUEST_RESET_ACTION_MODAL';
export const SERVICE_REQUEST_SET_CURRENT_SR = 'SERVICE_REQUEST_SET_CURRENT_SR';
export const SERVICE_REQUEST_UPDATE_CURRENT_SR = 'SERVICE_REQUEST_UPDATE_CURRENT_SR';

// SETTINGS MUTATIONS
export const SETTING_CHANGE_VALUE = 'SETTING_CHANGE_VALUE';
export const SETTING_CHANGE_VALUES = 'SETTING_CHANGE_VALUES';
export const SETTING_CHANGE_TABLE_OPTIONS = 'SETTING_CHANGE_TABLE_OPTIONS';
export const SETTING_PLATFORM_USERS = 'SETTING_PLATFORM_USERS';
export const SETTING_TECHNICIAN_USERS = 'SETTING_TECHNICIAN_USERS';
export const SETTING_CLOSE_ACTION_MODAL = 'SETTING_CLOSE_ACTION_MODAL';
export const SETTING_CHANGE_INFO = 'SETTING_CHANGE_INFO';
export const SETTING_ERROR = 'SETTING_ERROR';
export const SETTING_USER = 'SETTING_USER';
export const SETTING_TECHNICIAN = 'SETTING_TECHNICIAN';

// Comfort Credits Mutation

export const COMFORT_CREDITS_CHANGE_VALUE = 'COMFORT_CREDITS_CHANGE_VALUE ';
export const COMFORT_CREDITS_CHANGE_VALUES = 'COMFORT_CREDITS_CHANGE_VALUES';
export const COMFORT_CREDITS_CHANGE_TABLE_OPTION = 'COMFORT_CREDITS_CHANGE_TABLE_OPTION';
export const VOUCHERS_CHANGE_TABLE_OPTION = 'VOUCHERS_CHANGE_TABLE_OPTION';

// User Activities Mutation

export const USER_ACTIVITIES_CHANGE_VALUE = 'COMFORT_CREDITS_CHANGE_VALUE';
export const USER_ACTIVITIES_CHANGE_VALUES = 'USER_ACTIVITIES_CHANGE_VALUES';
export const USER_ACTIVITIES_CHANGE_TABLE_OPTION = 'USER_ACTIVITIES_CHANGE_TABLE_OPTION';

// Partner Review Mutation
export const PARTNER_REVIEW_CHANGE_VALUES = 'PARTNER_REVIEW_CHANGE_VALUES';
export const PARTNER_REVIEW_ORDER_SET = 'PARTNER_REVIEW_ORDER_SET';

// Promos Mutation
export const PROMO_CHANGE_VALUE = 'PROMO_CHANGE_VALUE';
export const PROMO_CHANGE_VALUES = 'PROMO_CHANGE_VALUES';

// Provider Plan Mutation
export const PROVIDER_PLAN_CHANGE_VALUES = 'PROVIDER_PLAN_CHANGE_VALUES';

// Adoption Mutation
export const ADOPTION_CHANGE_VALUES = 'ADOPTION_CHANGE_VALUES';

// Technician Mutation
export const TECHNICIAN_CHANGE_VALUES = 'TECHNICIAN_CHANGE_VALUES';

export const MEMBER_SUPPORT_SET_MEMBER = 'MEMBER_SUPPORT_SET_MEMBER';
export const PARTNER_DETAIL_CHANGE_VALUE = 'PARTNER_DETAIL_CHANGE_VALUE';
